/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Detail_Label_AvailableInputs */

const vi_product_lot_detail_label_available = /** @type {(inputs: Product_Lot_Detail_Label_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng khả dụng`)
};

/**

* @param {Product_Lot_Detail_Label_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_detail_label_available = /** @type {((inputs?: Product_Lot_Detail_Label_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Detail_Label_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_detail_label_available(inputs)
});